import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import HttpHelper from 'Services/HttpHelper'

const GetCustomer = customerId => {
    const url = HttpHelper.Proxy({ originalUrl: `${ServerEnv.Hydra()}/customers?unicity=${customerId}&expand=customer` })

    return axios.get(url)
}

const GetCustomerImgProfile = url => {
    return axios.get(url)
}

const getAllowReferrer = customerId => {
    // 249742966
    const url = HttpHelper.Proxy({ originalUrl: `${ServerEnv.MemberCalls2()}/products-v2/feelGreat/v3/checkAllowReferrer?countryCode=${StoreCountry.Country3()}&baId=${customerId}` })

    return axios.get(url)
}

export const Customers = {
    GetCustomer,
    GetCustomerImgProfile,
    getAllowReferrer
}
